const AvatarTypes = Object.freeze({
    "round": "round",
    "rectangle": "rectangle"
});
const AvatarSize = Object.freeze({
    "large": "large",
    "medium": "medium",
    "small": "small",
    "extra-small": "extra-small"
});
var AvatarProps = { AvatarTypes, AvatarSize };

export { AvatarProps as default };
//# sourceMappingURL=avatar.js.map
